import React from "react";

export default function VideoDisplay({ videoUrl }) {
    return (
        <>
            <div className="w-full h-full min-h-[180px] flex items-center justify-center">
                <div className="relative w-full h-0 pb-[56.25%]">
                    <iframe
                        frameborder="0"
                        allow="encrypted-media; fullscreen"
                        allowfullscreen
                        className="absolute top-0 left-0 w-full h-full rounded-md"
                        src={videoUrl+"?rel=0&modestbranding=1"}
                        title="Embedded Video"
                    />
                </div>
            </div>
        </>
    );
}
